// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const SERVER_FULL_NAME = "Modr\u00fd kon\u00edk";
export const SERVER_SLOGAN = "Str\u00e1nka pro maminky a budouc\u00ed maminky";
